__turbopack_context__.v({
  "iconLabel": "_5dRISG_iconLabel",
  "productsNumber": "_5dRISG_productsNumber",
  "wrapper": "_5dRISG_wrapper",
});
